import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

const REASON_MAX_LENGTH = 500;

function CancelAppointmentDialog({ open, onClose, onConfirm }) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const handleConfirm = () => {
    onConfirm(reason.trim() || null);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="cancel-appointment-dialog-title"
    >
      <DialogTitle id="cancel-appointment-dialog-title">Cancelar consulta</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          Tem certeza de que deseja cancelar a consulta?
        </DialogContentText>
        <TextField
          data-cy="cancel-reason-input"
          label="Motivo do cancelamento"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          fullWidth
          multiline
          minRows={3}
          autoFocus
          slotProps={{ htmlInput: { maxLength: REASON_MAX_LENGTH } }}
          helperText={`${reason.length}/${REASON_MAX_LENGTH}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Voltar</Button>
        <Button
          data-cy="confirm-cancel-btn"
          variant="contained"
          color="error"
          onClick={handleConfirm}
        >
          Cancelar consulta
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CancelAppointmentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default CancelAppointmentDialog;
